import React, { useState, useContext } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { AuthInfo } from '../AuthInfo';
import './NavMenu.css';

export const NavMenu = () => {
  const authContext = useContext(AuthContext);
  const [collapsed, setCollapsed] = useState(true);
  const toggleNavbar = () => { setCollapsed(!collapsed) };
  return (
    <header>
      <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
        <Container>
          <NavbarBrand tag={Link} to="/"><img alt="Networking Technologies logo" src="/nettechLogo.png" height="100"/></NavbarBrand>
          <NavbarToggler onClick={toggleNavbar} className="mr-2" />
          <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
            <ul className="navbar-nav flex-grow">
             {authContext.isReportReader &&
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/reports">Reports</NavLink>
              </NavItem>}
              {authContext.isAdministrator && <NavItem>
                <NavLink tag={Link} className="text-dark" to="/tenants">Manage Tenants</NavLink>
              </NavItem>}
              {authContext.isAdministrator && <NavItem>
                <NavLink tag={Link} className="text-dark" to="/reports/manage">Manage Reports</NavLink>
              </NavItem>}
              {authContext.isAuthenticated && <NavItem>
                <NavLink onClick={AuthInfo.logout} >Logout</NavLink>
                          </NavItem>}
                          {authContext.isNocProf && <NavItem>
                              <NavLink tag={Link} className="text-dark" to="/auvikDeviceReport">Auvik Device Reports</NavLink></NavItem>}

            </ul>
          </Collapse>
        </Container>
      </Navbar>
    </header>
  )
}
